import { render, staticRenderFns } from "./screen-selection-menu.vue?vue&type=template&id=1d6c97b6&scoped=true"
import script from "./screen-selection-menu.vue?vue&type=script&lang=js"
export * from "./screen-selection-menu.vue?vue&type=script&lang=js"
import style0 from "./screen-selection-menu.vue?vue&type=style&index=0&id=1d6c97b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c97b6",
  null
  
)

export default component.exports